<template>
    <div class="user-list">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2 class="mb-0">{{ $t('room_availability.title') }}</h2>
            <router-link :to="{ name: 'AddRoomAvailability' }" class="btn btn-primary">
                <b-icon icon="plus" class="icon-style"></b-icon>
                {{ $t('room_availability.add') }}
            </router-link>
        </div>

        <CrudTable :columns="fields" :data-sources="roomAvailabilities" :loader="isLoading"
            list-url="/room-availabilites" ref="action-table">
            <template #cell(sr_no)="data">
                {{ (currentPage - 1) * perPage + data.index + 1 }}
            </template>

            <template #cell(is_available)="data">
                <span class="badge px-3 py-1 rounded-pill"
                    :class="data.item.is_available ? 'bg-success text-white' : 'bg-danger text-white'">
                    {{ data.item.is_available ? $t('room_availability.available') : $t('room_availability.unavailable')
                    }}
                </span>
            </template>
            <template #cell(room_id)="data">
                <div class="d-flex flex-column">
                    <strong>{{ data.item.rooms?.hotel.name }} - {{ data.item.rooms?.room_number }}</strong>
                    <small class="text-muted">
                        {{ data.item.rooms?.room_type.name }} | {{ data.item.rooms?.bed_size.name }}
                    </small>
                </div>
            </template>

            <template #cell(actions)="data">
                <div class="d-flex gap-2">
                    <router-link :to="{ name: 'EditRoomAvailability', params: { id: data.item.id } }"
                        class="btn btn-outline-primary btn-sm" title="Edit">
                        <i class="fas fa-edit"></i>
                    </router-link>

                    <b-button variant="outline-danger" size="sm" @click="confirmDelete(data.item)">
                        <i class="fas fa-trash"></i>
                    </b-button>
                </div>
            </template>
        </CrudTable>

        <ConfirmDeleteModal v-if="selectedItem" :show.sync="showDeleteModal" :item-id="selectedItem.id"
            delete-url="/room-availabilites"
            :message="$t('room_availability.confirm_delete_message', { date: selectedItem.date })"
            success-message="$t('room_availability.deleted_successfully')"
            error-message="$t('common.something_went_wrong')" @deleted="handleItemDeleted" />

    </div>
</template>

<script>
import CrudTable from "@/components/CrudTable.vue";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";

export default {
    name: 'RoomAvailabilityList',
    components: {
        CrudTable,
        ConfirmDeleteModal
    },
    data() {
        return {
            roomAvailabilities: [],
            isLoading: false,
            currentPage: 1,
            perPage: 10,
            showDeleteModal: false,
            selectedItem: null,
            fields: [
                { key: 'sr_no', label: this.$t('common.sr_no'), sortable: false },
                { key: 'room_id', label: this.$t('room_availability.room_id'), sortable: true },
                { key: 'date', label: this.$t('room_availability.date'), sortable: true },
                { key: 'override_price', label: this.$t('room_availability.override_price'), sortable: true },
                { key: 'is_available', label: this.$t('room_availability.status'), sortable: true },
                { key: 'actions', label: this.$t('room_availability.actions'), sortable: false }
            ]
        };
    },
    methods: {
        confirmDelete(item) {
            this.selectedItem = item;
            this.showDeleteModal = true;
        },
        handleItemDeleted() {
            this.$refs['action-table'].refreshTableData();
            this.$bvToast.toast(this.$t('room_availability.deleted_successfully'), {
                title: this.$t('common.success'),
                variant: 'success',
                solid: true
            });
            this.showDeleteModal = false;
            this.selectedItem = null;
        }
    }
};
</script>
